import styled from 'styled-components';

import { spacing, subtitle2 } from 'ui/theme';
import { Layer } from 'ui/utility/layer';
import { CollapseStateContextProvider } from './context/CollapseStateContextProvider';

import { ContextProps, TreeViewContextProvider } from './context/TreeViewContextProvider';
import { JsonModeToggle } from './JsonModeToggle';
import { TreeRoot, TreeRootProps } from './TreeRoot';

export type JsonViewProps = Omit<ContextProps, 'identifier'> &
  TreeRootProps & {
    storageKey?: string;
    showToggle?: boolean;
    className?: string;
  };

const JsonViewContainer = styled.div`
  position: relative;
`;

const ToggletipContainer = styled(Layer)`
  position: absolute;
  top: ${spacing.half};
  right: ${spacing.base};

  > div {
    display: flex;
    align-items: center;
  }

  label {
    ${subtitle2}
    padding: ${spacing.quarter};
    margin: 0;
  }
`;

export const JsonView = ({
  collapseByDefault,
  showToggle = true,
  highlight,
  storageKey = 'generic',
  src,
  sort,
  tableColor,
  className,
}: JsonViewProps) => {
  return (
    <TreeViewContextProvider
      {...{
        collapseByDefault,
        highlight,
        tableColor,
        sort,
      }}
    >
      <CollapseStateContextProvider identifier={storageKey} src={src}>
        <JsonViewContainer className={className}>
          {showToggle && (
            <ToggletipContainer $priority={2}>
              <JsonModeToggle />
            </ToggletipContainer>
          )}
          <Layer $priority={1}>
            <TreeRoot src={src} />
          </Layer>
        </JsonViewContainer>
      </CollapseStateContextProvider>
    </TreeViewContextProvider>
  );
};
